import React from 'react';
import lodashGet from 'lodash/get';
import { makeStyles } from '@material-ui/core';
import { useFormatMessage } from 'react-intl-hooks';
import { addCommas } from '../../../utils';
import { skins } from '../skins';
import { HistoricalTrend } from '../HistoricalTrend';

const COPYRIGHT_YEAR = new Date().getFullYear();
const useStyles = makeStyles((theme)=> ({
    statsRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        maxWidth: '709px',
        marginTop: '32px',
        marginLeft: '32px',
        marginRight: 'auto',
        padding: '18px 0',
        height: '120px',
    },
    statsRowBottom: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        maxWidth: '709px',
        marginTop: '32px',
        marginLeft: 'auto',
        marginRight: 'auto',
        padding: '18px 0',
        height: '120px',
    },
    statsRowItemValue: {
        minWidth: '200px',
        fontSize: '48px',
        lineHeight: '68px',
        fontWeight: 500,
    },
    statsRowItemLabel: {
        fontSize: '24px',
        lineHeight: '32px',
    },
    disclaimerLeftAligned: {
        position: 'absolute',
        fontSize: '16px',
        lineHeight: '22px',
        bottom: 16,
        left: 20,
        maxWidth: 312,
        textAlign: 'left',
    },
    disclaimerCenterAligned: {
        fontSize: '16px',
        lineHeight: '24px',
        marginTop: 75,
    },
    compliance: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '14px',
        lineHeight: '20px',
        marginTop: '45px',
    },
    disclaimer: {
        display: 'flex',
        alignItems: 'center',
        textAlign: 'end',
    },
    disclaimerText: {
        width: '305px',
        marginRight: '16px',
    },
    copyright: {
        width: '320px',
        textAlign: 'start',
    }
}));

export default function StatsGrid(props) {
    const {
        medianDom: median_dom,
        medianDomTrend: median_dom_mm,
        medianPrice: median_price,
        medianPriceTrend: median_price_mm,
        activeListingsCount: active_listings_count,
        activeListingsCountTrend: active_listings_count_mm,
        newListingsCount: new_listings_count,
        fromMonth,
        toMonth,
        skin,
    } = props || {};
    const classes = useStyles(props);
    const t = useFormatMessage();
    const complianceStyle = {
        color: lodashGet(skins, `${skin}.COMPLIANCE_COLOR`),
        ...(skin === 'clouds'
            ? { flexDirection: 'column', alignItems: 'start' }
            : { marginTop: '65px' }
        ),
    };
    const disclaimerTextStyle = skin === 'clouds' ? { marginRight: '0', textAlign: 'start' } : {};
    const statsRowStyle = skin === 'clouds' ? { marginTop: '10px' } : {};
    const statsBottomRowStyle = skin === 'clouds' ? { marginTop: '10px' } : { marginTop: '16px' };
    return (
        <>
            <div className={classes.statsRow} style={statsRowStyle}>
                <div className={classes.statsRowItem}>
                    <div className={classes.statsRowItemValue}>
                        {median_price}

                        <HistoricalTrend
                            value={median_price_mm}
                            fromMonth={fromMonth}
                            toMonth={toMonth}
                            size="large"
                        />
                    </div>
                    <div className={classes.statsRowItemLabel} dangerouslySetInnerHTML={{__html: t({ id: 'median_price' }, { separator: '<br/>' })}}></div>
                </div>

                <div className={classes.statsRowItem}>
                    <div className={classes.statsRowItemValue}>
                        {`${active_listings_count > 0 ? addCommas(active_listings_count) : '-'}`}

                        <HistoricalTrend
                            value={active_listings_count_mm}
                            fromMonth={fromMonth}
                            toMonth={toMonth}
                            size="small"
                        />
                    </div>
                    <div className={classes.statsRowItemLabel} dangerouslySetInnerHTML={{__html: t({ id: 'active_listings' }, { separator: '<br/>' })}}></div>
                </div>

            </div>

            <div className={classes.statsRowBottom} style={statsBottomRowStyle}>
                <div className={classes.statsRowItem}>
                    <div className={classes.statsRowItemValue}>
                        {`${median_dom > 0 ? addCommas(median_dom) : '-'}`}

                        <HistoricalTrend
                            value={median_dom_mm}
                            fromMonth={fromMonth}
                            toMonth={toMonth}
                            size="small"
                        />
                    </div>
                    <div className={classes.statsRowItemLabel} dangerouslySetInnerHTML={{__html: t({ id: 'median_dom' }, { separator: '<br/>' })}}></div>
                </div>

                <div className={classes.statsRowItem}>
                    <div className={classes.statsRowItemValue}>
                        {`${new_listings_count > 0 ? addCommas(new_listings_count) : '-'}`}
                    </div>
                    <div className={classes.statsRowItemLabel} dangerouslySetInnerHTML={{__html: t({ id: 'new_listings' }, { separator: '<br/>' })}}></div>
                </div>
            </div>

            <div className={classes.compliance} style={complianceStyle}>
                <div className={classes.copyright}>
                    <img src={lodashGet(skins, `${skin}.LR_LOGO_PATH`)} height={16} alt="LR Logo" />
                    <div>
                        &copy; ListReports {COPYRIGHT_YEAR}, {t({ id: 'copyright' })}
                    </div>
                </div>
                <div className={classes.disclaimer}>
                    <div className={classes.disclaimerText} style={disclaimerTextStyle}>{t({ id: 'disclaimer' })}</div>
                    <img src={lodashGet(skins, `${skin}.EQUAL_HOUSING_LOGO_PATH`)} height={24} alt="Equal Housing logo" />
                </div>
            </div>
        </>
    );
}
